import { Trans } from '@lingui/react/macro';

import { FieldValueRow } from './FieldValueRow';

export interface FieldValuesListProps {
  values: string[];
  defaultDisplayValue: string | null;
  isPending: boolean;
  onSetDefault: (value: string) => void;
}

export const FieldValuesList = ({
  values,
  defaultDisplayValue,
  isPending,
  onSetDefault,
}: FieldValuesListProps) => {
  if (values.length === 0) {
    return (
      <ul className="vai-divide-y vai-divide-gray-200 vai-bg-white vai-overflow-hidden">
        <li className="vai-text-sm vai-text-gray-500">
          <Trans>No values yet. Add one to get started.</Trans>
        </li>
      </ul>
    );
  }

  return (
    <ul className="vai-divide-y vai-divide-gray-200 vai-bg-white vai-overflow-hidden">
      {values.map((value) => (
        <FieldValueRow
          key={value}
          value={value}
          isDefault={value === defaultDisplayValue}
          onSetDefault={() => onSetDefault(value)}
          isPending={isPending}
        />
      ))}
    </ul>
  );
};
